module.exports = __webpack_public_path__ + "assets/clarity.696f1837.svg";